import type { SxProps, Theme } from "@mui/material";
import { alpha } from "@mui/material/styles";

export type SurfaceActionTone = "primary" | "success" | "warning" | "error" | "purple";

/**
 * Icônes d'action sur panneau clair : en **light**, fond discret + bordure douce,
 * survol léger (pas de pastille néon ni remplissage plein).
 * En **dark**, conserve le style « halo » coloré existant.
 */
export function surfaceActionIconButtonSx(theme: Theme, tone: SurfaceActionTone): SxProps {
  const s = theme.palette.saas;

  const mainColor =
    tone === "primary"
      ? s.accentBlue
      : tone === "purple"
        ? s.accentPurple
        : tone === "success"
          ? theme.palette.success.main
          : tone === "warning"
            ? theme.palette.warning.main
            : theme.palette.error.main;

  if (s.scheme === "light") {
    const fg =
      tone === "primary"
        ? s.accentBlue
        : tone === "purple"
          ? s.accentPurple
          : tone === "success"
            ? theme.palette.success.dark
            : tone === "warning"
              ? theme.palette.warning.dark
              : theme.palette.error.dark;

    return {
      color: fg,
      backgroundColor: s.nestedShade,
      border: `1px solid ${s.border}`,
      "&:hover": {
        backgroundColor: alpha(mainColor, 0.1),
        borderColor: alpha(mainColor, 0.28),
        boxShadow: "none",
        transform: "scale(1.04)",
      },
    };
  }

  // Dark : style contrasté inchangé (fond coloré léger + hover plein)
  return {
    color: mainColor,
    backgroundColor: alpha(mainColor, 0.1),
    border: `1px solid ${alpha(mainColor, 0.3)}`,
    "&:hover": {
      backgroundColor: mainColor,
      color: theme.palette.getContrastText(mainColor),
      transform: "scale(1.05)",
      boxShadow: `0 4px 12px ${alpha(mainColor, 0.3)}`,
    },
  };
}
